import { Query } from '../../_base/actionBus/Query';
import { ChatMessage } from '../../models/chat/ChatMessage';

export class GetMessages extends Query<ChatMessage[]> {}
